<i style="color: #f35309" class="fa fa-circle-o-notch fa-spin"></i>